import { RoleName } from "consts/auth";
import useActions from "./useActions";
import { whereUserRole } from "./helpers";

export const useECommerceActions = () => {
    const actions = useActions();

    const withECommerceApplications = whereUserRole(RoleName.OnboardingE);

    const getApplications = (query?: string) => actions.getApplications(
        withECommerceApplications(query)
    );

    const downloadCsv = (query?: string) => actions.downloadCsv(
        withECommerceApplications(query)
    );

    return {
        getApplications,
        downloadCsv
    };
};

export default useECommerceActions;
